import { useEffect, useState } from 'react';
import type { StoreStockErrors } from '../../components';

export const useGetLocation = () => {
  const [errors, setErrors] = useState<StoreStockErrors>({ location: { error: false } });
  const [isLoading, setIsLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    if (!errors.location?.error) {
      setShowMessage(false);
    }
  }, [errors]);

  return {
    setErrors,
    errors,
    showMessage,
    setIsLoading,
    setShowMessage,
    isLoading,
  };
};
